import React from 'react';
import { Button, Input, InputGroup, InputRightElement } from '@chakra-ui/react';

type Props = {
  placeholder?: string;
  onChange: React.ComponentProps<typeof Input>['onChange'];
  value: string;
};

export function PasswordInput(props: Props) {
  const { placeholder, onChange, value } = props;
  const [show, setShow] = React.useState(false);
  return (
    <InputGroup size="md">
      <Input
        onChange={onChange}
        placeholder={placeholder}
        pr="4.5rem"
        type={show ? 'text' : 'password'}
        value={value}
      />
      {value ? (
        <InputRightElement width="4.5rem">
          <Button h="1.75rem" size="sm" onClick={() => setShow(!show)}>
            {show ? t('Hide') : t('Show')}
          </Button>
        </InputRightElement>
      ) : null}
    </InputGroup>
  );
}
